import {
    RETIREMENT_CALCULATOR_SHOW_RESULT_SUMMARY
} from "../../../actions/retirementCalculator/retirementCalculatorForm"
import { fireGtmEvent } from "../gtmEvents";
import { submitEarnEvent, earnEventMap } from '../rewards';
import { findOtherEventIndex, otherEventTracking } from '../otherEventTracking';;

export const retirementCalculatorFieldTracking = (store, next, action) => {
    const result = next(action);
    let otherEventIndex;

    const field = (() => {
        switch (action.type) {
            case RETIREMENT_CALCULATOR_SHOW_RESULT_SUMMARY:
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                submitEarnEvent(earnEventMap.retirementSaving)
                    .catch(error => console.warn("submitEarnEvent failed:", error?.response?.data || error.message));

                fireGtmEvent('calculator_complete', { calculator_type: 'Retirement Calculator' });
                return 'Retirement calculator';
        }
    })();

    if (field) {
        otherEventTracking(action.type, otherEventIndex, field);
    }

    return result;
};
